module.exports = __webpack_public_path__ + "static/img/send.2d6b9171.svg";